import { Observable } from 'rxjs';
import { Alarm } from '../../model/alarm/alarm';
import { AlarmLite } from '../../model/alarm/alarm-lite';
import { AlarmGateway } from './alarm.gateway';
import { inject } from '@angular/core';
import {
  DataModel,
  HttpFilter,
  RestService,
} from '@infodata-group/inf-commons';
import { AlarmFactory } from '../../factory/alarm/alarm.factory';
import { AlarmLiteFactory } from '../../factory/alarm/alarm-lite.factory';

export class AlarmSbGateway extends AlarmGateway {
  private restService = inject(RestService);

  public get$(httpFilter: HttpFilter): Observable<Alarm[]> {
    return this.restService.getAll(new AlarmFactory(), {
      httpFilter,
      showLoading: false,
    });
  }
  public getLite$(): Observable<AlarmLite[]> {
    return this.restService.getAll(new AlarmLiteFactory(), {
      showLoading: false,
    });
  }
  public options$(): Observable<DataModel> {
    return this.restService.options(new AlarmFactory().getApi(), {
      showLoading: false,
    });
  }
  public update$(dto: any): Observable<any> {
    return this.restService.put(new AlarmFactory().getApi(), dto);
  }
}
